import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { GutachtenStatiService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [GutachtenStatiService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class GutachtenStatiServiceModule {}
